module.exports = __webpack_public_path__ + "img/gas-outline-grey.b6d43225.svg";